import * as React from 'react';
import { IoMdArrowDropright } from 'react-icons/io';
import { observer } from 'mobx-react';
import { AiFillFile } from 'react-icons/ai';
import { FaFolder, FaFolderOpen } from 'react-icons/fa';
import { MenuModel } from '../../../models';
import style from './SideMenu.module.scss';
import { JoinClassName } from '../../../utils/string';

interface SideMenuItemActions {
  onSelect: (menu: MenuModel) => void;
}

interface SideMenuItemProps extends SideMenuItemActions {
  menu: MenuModel;
  className?: string;
  isFavorite?: boolean;
}

const getChildClassName = (level: string) => {
  switch (level) {
    case '2':
      return style.first;
    case '3':
      return style.secondary;
    case '4':
      return style.tertiary;
    case '5':
      return style.quaternary;
    default:
      return style.quaternary;
  }
};

@observer
export class SideMenuItem extends React.Component<SideMenuItemProps> {
  render() {
    const {
      menu,
      onSelect,
      className,
      isFavorite,
    } = this.props;

    return (
      <React.Fragment>
        <div
          // 에이전트가 화면을 열 때 누르는 지점.
          //
          // 폴더는 MenuModel 기본값 '/' 를 갖는다. 경로로 앵커를 달면 폴더 여럿이
          // 같은 값을 갖게 되므로 화면과 폴더를 다른 속성으로 나눈다. 폴더에도
          // 짚을 자리가 있어야 하는 이유는, 화면 앵커가 그 폴더를 펼치기 전에는
          // DOM 에 아예 없기 때문이다.
          data-el-menu={menu.path && menu.path !== '/' ? menu.path : undefined}
          data-el-menu-group={!menu.path || menu.path === '/' ? menu.id : undefined}
          className={JoinClassName.make([
            style.menu,
            className,
            menu.isEnabled ? style.open : false,
            getChildClassName(isFavorite ? '3' : menu!.level!),
          ])}
          onClick={() => onSelect(menu)}
        >
          {menu.children && menu.children.length > 0 ? (
            parseInt(menu.level || '0', 10) > 2 ? (
              menu.isEnabled ? <FaFolderOpen className={style.colorClose} /> : <FaFolder className={style.colorOpen} />
            ) : (
              <IoMdArrowDropright
                className={menu.isEnabled ? style.active : undefined}
              />
            )
          ) : (
            <AiFillFile />
          )}
          <p>{menu.textT}</p>
        </div>
        {menu.isEnabled
          && menu.children?.map((x) => (
            <SideMenuItem
              key={x.id}
              className={style.open}
              menu={x}
              onSelect={(selected) => onSelect(selected)}
            />
          ))}
      </React.Fragment>
    );
  }
}
